import { createSelector } from 'reselect'

import { entityList$ } from 'syft-acp-core/reducers/generators/entities'

export const getCities = createSelector(
  citiesState => citiesState,
  cities => entityList$(cities, {})
)
